import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from '../hooks/use-toast';
import { authForgotPassword } from '../api';
import { Mail, KeyRound, ArrowLeft } from 'lucide-react';

const ForgotPassword = () => {
  const { dir, lang } = useLang();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authForgotPassword(email);
      setSent(true);
      toast({ title: lang === 'ar' ? 'تم إرسال الطلب' : 'Request submitted' });
    } catch {
      toast({ title: 'Failed', variant: 'destructive' });
    } finally { setLoading(false); }
  };

  return (
    <div className="pt-24 pb-16 min-h-screen flex items-center noise-bg" dir={dir}>
      <div className="absolute inset-0 spot-light pointer-events-none" />
      <div className="max-w-md w-full mx-auto px-6 relative">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-[#2563eb]/15 border border-[#2563eb]/30 flex items-center justify-center mb-4">
            <KeyRound className="w-6 h-6 text-[#3b82f6]" />
          </div>
          <h1 className="font-display text-3xl md:text-4xl text-[#0a0a0a]">{lang === 'ar' ? 'نسيت كلمة المرور؟' : 'Forgot Password?'}</h1>
          <p className="mt-2 text-sm text-[#111827]/60">{lang === 'ar' ? 'أدخل بريدك الإلكتروني وسنرسل لك تعليمات الاستعادة' : 'Enter your email and we\u2019ll help you reset it.'}</p>
        </div>

        <div className="glass-card rounded-2xl p-8">
          {sent ? (
            <div className="text-center py-4">
              <div className="w-16 h-16 mx-auto rounded-full bg-blue-500/15 border border-blue-400/40 flex items-center justify-center mb-4">
                <Mail className="w-7 h-7 text-blue-400" />
              </div>
              <div className="text-[#0a0a0a] font-medium mb-2">{lang === 'ar' ? 'تم استلام طلبك' : 'Request Received'}</div>
              <p className="text-sm text-[#111827]/60 mb-2">{lang === 'ar' ? 'إذا كان البريد مسجلاً، فقد تم إنشاء رابط استعادة صالح لمدة ساعة.' : 'If the email exists, a reset link valid for 1 hour has been generated.'}</p>
              <p className="text-xs text-[#111827]/50 mb-4">{lang === 'ar' ? 'يرجى التواصل مع الأدمن للحصول على الرابط (خدمة الإيميل غير مفعّلة بعد).' : 'Please contact the admin to retrieve your reset link (email service not yet configured).'}</p>
              <Link to="/login"><Button className="gold-button rounded-md h-11 w-full text-sm">{lang === 'ar' ? 'العودة للدخول' : 'Back to Sign In'}</Button></Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-[#0a0a0a] text-xs uppercase tracking-widest mb-2 block">{lang === 'ar' ? 'البريد الإلكتروني' : 'Email Address'}</Label>
                <div className="relative">
                  <Mail className="w-4 h-4 text-[#2563eb]/60 absolute top-1/2 -translate-y-1/2 start-3" />
                  <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 ps-10 bg-[#ffffff] border-[#2563eb]/25 text-[#111827] focus-visible:ring-[#2563eb]/40" />
                </div>
              </div>
              <Button type="submit" disabled={loading} className="gold-button rounded-md h-12 w-full text-sm">{loading ? '…' : (lang === 'ar' ? 'إرسال طلب الاستعادة' : 'Send Reset Request')}</Button>
              <Link to="/login" className="flex items-center justify-center gap-2 text-xs text-[#111827]/60 hover:text-[#3b82f6] pt-2">
                <ArrowLeft className="w-3 h-3 rtl:hidden" /> {lang === 'ar' ? 'العودة للدخول' : 'Back to Sign In'}
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
